import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Page pleine remplacée par le volet dossier — cf. `overview.tsx`.
 * Le `track("Timeline Opened")` vit désormais dans le volet, sinon l'événement serait perdu
 * (la redirection sort avant tout rendu).
 */
export const Route = createFileRoute("/_authed/_dashboard/claims/$claimId/timeline")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/claims",
      search: { claimId: params.claimId, claimTab: "timeline" },
    });
  },
});
